import {Button, Form, Input, message, Typography, Upload} from "antd"
import {useNavigate} from "react-router-dom"
import {ArrowLeft, File, Paperclip, Send} from "lucide-react"
import React, {useEffect, useState} from "react"
import {images} from "../../../constants";
import Localization from "../../../components/Localizations/Localization";
import {useTranslation} from "react-i18next";
import {FullscreenControl, Map, Placemark, SearchControl, YMaps} from "@pbe/react-yandex-maps";
import {playFeedbackWave} from "../../../utils/feedbackWave";

const {Dragger} = Upload
const {Text} = Typography

const DeviceReregistrationSecondForm = ({handleClear, uploadProps}) => {
    const {t} = useTranslation();
    const navigate = useNavigate()
    const [form] = Form.useForm()
    const [coordinate, setCoordinate] = useState("");

    useEffect(() => {

        // Retrieve data from step 1
        const step1Data = JSON.parse(localStorage.getItem("deviceReRegistrationStep1") || "{}")

        // Retrieve data from step 2
        const step2Data = form.getFieldsValue()

        // Merge both step data
        const completeFormData = {
            ...step1Data,
            ...step2Data,
        }

        console.log(completeFormData)
    })

    const handleSubmit = async () => {
        try {
            await form.validateFields()

            if (coordinate === "") {
                alert(t("pages.devices.registrationForm.common.error.error2"));
                return;
            }

            // Retrieve data from step 1
            const step1Data = JSON.parse(localStorage.getItem("deviceReRegistrationStep1") || "{}")

            // Retrieve data from step 2
            const step2Data = form.getFieldsValue()


            // Merge both step data
            const completeFormData = {
                ...step1Data,
                ...step2Data,
            }

            console.log("Sending complete form data to backend:", completeFormData)

            try {
                // Send the merged data to backend
                const response = await fetch("https://your-backend-api.com/device/register", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(completeFormData),
                })

                if (response.ok) {
                    playFeedbackWave('success');
                    message.success("Device registered successfully")

                    // Clear localStorage after successful submission
                    localStorage.removeItem("deviceReRegistrationStep1")
                    localStorage.removeItem("deviceReRegistrationStep2")

                    navigate("/device/re/registration")
                } else {
                    playFeedbackWave('failure');
                    message.error("Failed to re-register device")
                }
            } catch (error) {
                message.error("Failed to send data to server")
            }
        } catch (error) {
            console.error("Error submitting form:", error)
        }
    }

    const handleBack = () => {
        // Save current form data before going back
        const currentData = form.getFieldsValue()
        localStorage.setItem("deviceReRegistrationStep2", JSON.stringify(currentData))

        navigate("/device/re/registration")
    }

    return (
        <div className="device-registration-container">
            <div className="banner">
                <div className="banner-logo">
                    <img src={images.deviceRegistrationBanner} alt="fiscalBOX"/>
                </div>
                <div className="banner-text">
                    <h1>{t("pages.devices.reRegistrationForm.title")}</h1>
                    <p>{t("pages.devices.reRegistrationForm.description")}</p>
                </div>
            </div>

            <div className="navigation-bar">
                <div>
                    <Localization/>
                </div>
                <div className="step-indicator">
                    <span className="step" onClick={handleBack}>{t("pages.devices.registrationForm.steps.step1")}</span>
                    <span className="step-divider"></span>
                    <span className="step active">{t("pages.devices.registrationForm.steps.step2")}</span>
                </div>
            </div>

            <div className="form-title">
                <h2>{t("pages.devices.reRegistrationForm.form2.title")}</h2>
                <p>{t("pages.devices.registrationForm.form1.description")}</p>
            </div>

            <Form form={form} layout="vertical" className="registration-form">
                <Form.Item label={t("pages.devices.registrationForm.form1.field2.label")} name="companyName"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field2.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field4.label")} name="inn"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field4.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field6.label")} name="marketName"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field6.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field9.label")} name="marketCity"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field9.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field10.label")} name="marketDistrict"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field10.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field11.label")} name="marketStreet"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field11.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field12.label")} name="marketMahalla"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field12.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field13.label")} name="marketLocation"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <YMaps>
                        <div style={{width: '100%', height: '500px'}}>
                            <Map
                                defaultState={{center: [41.2988036, 69.2721706], zoom: 10}}
                                onClick={(e) => {
                                    const coords = e.get("coords");
                                    setCoordinate(coords);
                                    form.setFieldsValue({marketLocation: coords});
                                }}
                                style={{width: '100%', height: '100%'}}
                            >
                                <FullscreenControl/>
                                <SearchControl options={{
                                    float: 'right'
                                }}/>
                                <Placemark geometry={[coordinate[0], coordinate[1]]}/>
                            </Map>
                        </div>
                    </YMaps>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field14.label")} name="phoneNumber"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field14.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field15.label")} name="certificateFile"
                           className="upload-form-item"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <div className="upload-section">
                        <Dragger {...uploadProps}>
                            <p className="ant-upload-drag-icon">
                                <Paperclip size={28}/>
                            </p>
                            <p className="ant-upload-text">{t("pages.devices.registrationForm.common.upload.label")}</p>
                            <p className="ant-upload-hint">
                                {t("pages.devices.registrationForm.form1.field15.upload.description")}
                            </p>
                        </Dragger>
                        <div className="upload-info">
                            <Text type="secondary">
                                <File size={14} style={{marginRight: "5px", verticalAlign: "middle"}}/>
                                {t("pages.devices.registrationForm.common.upload.secondary")}
                            </Text>
                        </div>
                    </div>
                </Form.Item>

                <Form.Item label={t("pages.devices.reRegistrationForm.form2.field1.label")} name="contractFile"
                           className="upload-form-item"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <div className="upload-section">
                        <Dragger {...uploadProps}>
                            <p className="ant-upload-drag-icon">
                                <Paperclip size={28}/>
                            </p>
                            <p className="ant-upload-text">{t("pages.devices.registrationForm.common.upload.label")}</p>
                            <p className="ant-upload-hint">
                                {t("pages.devices.reRegistrationForm.form2.field1.upload.description")}
                            </p>
                        </Dragger>
                        <div className="upload-info">
                            <Text type="secondary">
                                <File size={14} style={{marginRight: "5px", verticalAlign: "middle"}}/>
                                {t("pages.devices.registrationForm.common.upload.secondary")}
                            </Text>
                        </div>
                    </div>
                </Form.Item>

                <div className="button-container">
                    <Button icon={<ArrowLeft size={16}/>} onClick={handleBack} className="back-step-button">
                        {t("pages.devices.registrationForm.buttons.button2")}
                    </Button>
                    <Button icon={<Send size={16}/>} type="primary" onClick={handleSubmit} className="submit-button">
                        {t("pages.devices.registrationForm.buttons.button1")}
                    </Button>
                </div>
            </Form>
        </div>
    )
}

export default DeviceReregistrationSecondForm

